<div *ngFor="let category of categories">
  <div class="category-header border-bottom p-2 m-2">{{category.title}}</div>
  <yw-shared-image-list class="d-flex justify-content-start flex-wrap"
                        (clicked)="clickedImage($event)"
                        [images]="category.images"></yw-shared-image-list>
</div>
